export const MEETING_REFERENCE_TYPES = {
  IDP_GOAL: 'IDP_GOAL',
  IDP_ACTION: 'IDP_ACTION',
  PERFORMANCE_FEEDBACK_RESULT: 'PERFORMANCE_FEEDBACK_RESULT',
};
